import ownerDocument from './owner-document';
export default function ownerWindow(node) {
    const doc = ownerDocument(node);
    return doc.defaultView || window;
}
//# sourceMappingURL=owner-window.js.map